import {NavigateAway} from '@staff-app/actions/position.actions';
import {EligibilityAndAvailabilityDTO} from '@staff-app/models/EligibilityAndAvailabilityDTO';
import {
  EligibilityAndAvailabilityActionTypes,
  EligibilityAndAvailabilityActions
} from '@staff-app/actions/eligibility-and-availability.actions';
import {CommonActions, CommonActionTypes} from '@store/actions/common.actions';

export const initialState: EligibilityAndAvailabilityDTO = null;

export function reducer(
  state = initialState,
  action: EligibilityAndAvailabilityActions | CommonActions
): EligibilityAndAvailabilityDTO {
  switch (action.type) {
    case EligibilityAndAvailabilityActionTypes.GetEligibilityAndAvailabilitySuccessful:
      return action.payload;
    case EligibilityAndAvailabilityActionTypes.SaveEligibilityAndAvailabilitySuccessful:
    case EligibilityAndAvailabilityActionTypes.NavigateAway:
    case CommonActionTypes.NavigateToSubmitPage:
      return initialState; // clear record
    default: {
      return state;
    }
  }
}

export const getEligibilityAndAvailability = (
  state: EligibilityAndAvailabilityDTO
) => state;
